/**
 * IMPORTS
 */
import { Bell } from "lucide-react";

import { useContagemNotificacoes } from "@/hooks/conversa-cliente/use-notificacoes";

/** Ícone do item "Notificações" do menu, com bolinha de não lidas. */
function IconeMenuNotificacoes({ className }: { className: string }) {
  const { data: naoLidas = 0 } = useContagemNotificacoes();

  return (
    <span className="relative inline-flex">
      <Bell className={className} />
      {naoLidas > 0 && (
        <span className="absolute -right-2 -top-2 flex h-4 min-w-4 items-center justify-center rounded-full bg-red-600 px-1 text-[10px] font-semibold leading-none text-white">
          {naoLidas > 9 ? "9+" : naoLidas}
          <span className="sr-only"> não lidas</span>
        </span>
      )}
    </span>
  );
}

/**
 * EXPORTS
 */
export { IconeMenuNotificacoes };
